import React, { useState, useRef } from "react";

import {
  Input,
  Button,
  Stack,
  Card,
  CardBody,
  Alert,
  AlertIcon,
  AlertDescription,
} from "@chakra-ui/react";

function Uploader({ id, setImages }) {

  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();

  const handleClick = () => inputRef.current.click();
  const clearInput = () => (inputRef.current.value = "");

  const handleFile = async () => {
    const image = inputRef.current.files[0];

    setError(false);
    setSuccess(false);
    setLoading(true);

    if (!["image/jpeg"].includes(image.type)) {
      setError("Select a .jpg file");
      clearInput();
      setLoading(false);
      return;
    }

    if (image.size > 1048576) {
      setError("Maximum image size: 1M");
      clearInput();
      setLoading(false);
      return;
    }

    let url = `https://media.seamarinetransport.com/php/upload.php`;

    const form_data = new FormData();
    form_data.append("image", image);
    form_data.append("id", id);

    let headers = {
      method: "POST",
      body: form_data,
    };

    try {
      const response = await fetch(url, headers);

      if (!response.ok) {
        setError("Error uploading image");
        clearInput();
        setLoading(false);
        return;
      }

      setSuccess(true);
      clearInput();
      setLoading(false);
      pushImage();
      setTimeout(() => {
        setSuccess(false);
      }, 2000);
    } catch (err) {
      clearInput();
      setError("Error uploading image");
      setLoading(false);
      console.error("Error:", err);
      return;
    }
  };

  function pushImage() {
    const newImage = { name: `${id}.jpg`, id: id };
    if (newImage) {
      setImages((prevImages) => [newImage, ...prevImages]);
    }
  }

  return (
    <>
      <Card
        w="100%"
        rounded={4}
        boxShadow="sm"
      >
        <CardBody>
          <Stack
            direction="column"
            spacing={4}
          >
            {error && (
              <Alert
                status="error"
                variant="solid"
              >
                <AlertIcon />
                <AlertDescription lineHeight="1.2">
                  <b>Error:</b> {error}
                </AlertDescription>
              </Alert>
            )}

            {success && (
              <Alert
                status="success"
                variant="solid"
              >
                <AlertIcon />
                <AlertDescription lineHeight="1.2">
                  <b>Success:</b> Image uploaded successfully
                </AlertDescription>
              </Alert>
            )}

            <Input
              type="file"
              display="none"
              ref={inputRef}
              onChange={handleFile}
              accept="image/*"
            />

            <Stack>
              <Button
                colorScheme="blue"
                onClick={handleClick}
                rounded={4}
                isLoading={loading}
                loadingText="Uploading"
              >
                Upload Image 
              </Button>
            </Stack>
          </Stack>
        </CardBody>
      </Card>
    </>
  );
}

export default Uploader;
